module.exports = __webpack_public_path__ + "img/NL544.d2fdefc6.png";